<template>
    <div class="container px-0">
        <span class="poppins-regular" v-for="(label, index) in labels" :key="index"
            :class="[index !== labels.length - 1 ? 'text-secondary' : 'text-dark poppins-bold' ]">
            {{ index !== labels.length - 1 ? label + ' > ' : label }}
        </span>
    </div>
</template>

<script setup>

    const props = defineProps({
        labels: {
            type: Array,
            required: false,
            default: () => (['Label 1', 'Label 2', 'Label 3']),
        }
    })
</script>

<style lang="scss" scoped>

</style>